<main [@fadeInOut] id="main-heading" role="main" tabindex="0">
  <div class="col-sm-11 center-block">
    <div class="row">
      <div class="heading-container">
        <h1 tabindex="0" aria-label="ESG Submission Dashboard" role="heading" aria-level="1">ESG Submission Dashboard</h1>
        <p tabindex="0">
          Welcome to the submission dashboard for submissions made to the FDA's
          Office of the Commissioner (OC) via the Electronic Submissions Gateway (ESG) connection.
          Search to locate any specific submission, and click on the "Download Receipts" link in the Submission Status field to review the submission receipts.
          A Failed submission will have any error messages within the .xml receipt file.
        </p>
      </div>
    </div>
    <div class="date-range">
      <div class="date-range-filter">
        <ejs-dropdownlist #ddDateRangeLimit
                          [width]="150"
                          [dataSource]="dateRangeDataSource"
                          (change)="dateRangeSelectionChanged(ddDateRangeLimit.value)"
                          [value]="selectedDateRangeFilter"
                          tabindex="0"
                          role="listbox"
                          aria-label="date range selection">
        </ejs-dropdownlist>
      </div>
    </div>
    <div class="row top-space">
      <div class="col-sm-12 top-space">
        <div class="row bottom-padding">
          <div class="col-sm-12" aria-label="submission grid area" tabindex="0">
            <ejs-tooltip #tooltip id="tooltip" (beforeRender)="tooltipValue($event)" target=".e-tooltipcolumn" [enableHtmlParse]="false">
              <ejs-grid id="submissionGrid" #submission_grid [dataSource]="submission_grid_data"
                        allowPaging="true"
                        allowSorting="true" [pageSettings]="initialPage" height="570"
                        allowScrolling="true" [toolbar]="toolbarOptions"
                        allowFiltering="true" (actionBegin)="begin($event)"
                        tabindex="0" aria-label="submission grid">
                <e-columns>
                  <e-column tabindex="0" [customAttributes]="clipmodecolumn" field="sourceFileName" headerText="Submission Name" width="350" clipMode="EllipsisWithTooltip">
                    <ng-template #template let-data>
                      <a class='pointer underline'
                         (click)='downloadSourceFile(data.sourceFilePath, data.sourceFileName)'>
                        <i class="fas fa-download"
                           title="Download the file"></i>&nbsp;{{data.sourceFileName}}
                      </a>
                    </ng-template>
                  </e-column>
                  <e-column tabindex="0" [customAttributes]="clipmodecolumn" field="submissionStatusDescription" headerText="Status" clipMode="EllipsisWithTooltip" width="250">
                    <ng-template #template let-data tabindex="0">
                      <div class="status" *ngIf="statusProcessing !== data.submissionStatusCode">
                        <i *ngIf="data.submissionStatusCode === 13" class="fa-solid fa-check icon-success"></i>
                        <i *ngIf="data.submissionStatusCode === 7" class="fa-solid fa-xmark icon-danger"></i>
                        <span> {{ data?.submissionStatusDescription }}</span>
                        <a class="pointer underline download-align"
                           (click)="downloadFile(data.submissionId, data.sourceFileName)"
                           (keydown.enter)="downloadFile(data.submissionId, data.sourceFileName)"
                           aria-label="Download Receipts">
                          <i class="fas fa-download" aria-hidden="true"></i>Receipts
                        </a>
                      </div>
                      <div *ngIf="statusProcessing === data.submissionStatusCode">
                        <span>{{ data?.submissionStatusDescription }}</span>
                      </div>
                    </ng-template>
                  </e-column>
                  <e-column [customAttributes]="clipmodecolumn" field="documentType" headerText="Document Type" clipMode="EllipsisWithTooltip" width="350"></e-column>
                  <e-column [customAttributes]="clipmodecolumn" field="submissionCoreId" headerText="Submission Core ID" clipMode="EllipsisWithTooltip" width="350"></e-column>
                  <e-column [customAttributes]="clipmodecolumn" field="formName" headerText="Form Name" clipMode="EllipsisWithTooltip" width="250"></e-column>
                  <e-column [customAttributes]="clipmodecolumn" field='formVersion' headerText='Form Version' width="150"></e-column>
                  <e-column [customAttributes]="clipmodecolumn" field="setId" headerText="Set ID" clipMode="EllipsisWithTooltip" width="300"></e-column>
                  <e-column [customAttributes]="clipmodecolumn" field="rootId" headerText="Root ID" clipMode="EllipsisWithTooltip" width="300"></e-column>
                  <e-column [customAttributes]="clipmodecolumn" field="submittedBy" headerText="Submitted By" clipMode="EllipsisWithTooltip" width="200"></e-column>
                  <e-column [customAttributes]="clipmodecolumn" field='formatedCreateDate'
                            [allowFiltering]="false" headerText='Submitted Date/Time' type="datetime"
                            [format]='formatOptionsWithTime' clipMode="EllipsisWithTooltip" width='200'>
                  </e-column>

                </e-columns>
              </ejs-grid>
            </ejs-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="loading">
      <div id="loading"></div>
    </div>
  </div>
</main>
